import { render, staticRenderFns } from "./ClientLink.vue?vue&type=template&id=0323ff6b&"
import script from "./ClientLink.vue?vue&type=script&lang=js&"
export * from "./ClientLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports